import React from 'react';
import TitleWithIcon from '../../components/common/TitleWithIcon';
import SectionSignUp from '../../components/section/SectionSignUp';
import { SectionSupportModules } from '../../components/section/SectionSupportModules';
import { SectionSupportRules } from '../../components/section/SectionSupportRules';
import { TEXT_KEYS } from '../../constants/textKeys';
import IMAGES_PATH from '../../Images';
import { t } from '../../translation/translation';
import './style.css'
import { useNavigation } from '../../hooks/useNavigate';

export const Support = () => {

    const {
        goToDoodle,
        goToDonate,
    } = useNavigation()

    const firstTitlePart = <h2 className='text-blue'>{t(TEXT_KEYS.SUPPORT_MAIN_TITLE_1)}</h2>
    const secondTitlePart = <h2 className='text-black'>{t(TEXT_KEYS.SUPPORT_MAIN_TITLE_2)}</h2>
    const thirdTitlePart = <h2>{t(TEXT_KEYS.SUPPORT_MAIN_TITLE_3)} <h2 className='text-blue'>{t(TEXT_KEYS.SUPPORT_MAIN_TITLE_4)}</h2></h2>

    return (
        <div className='page-container'>
            <TitleWithIcon
                imagePath={IMAGES_PATH.ICON_DOODLE}
                firstTitlePart={firstTitlePart}
                secondTitlePart={secondTitlePart}
                thirdTitlePart={thirdTitlePart}
                isIconContainer={false}
                isButtonBottom={true}
                onClickButtonLeft={goToDoodle}
                onClickButtonRight={goToDonate}
            />
            <SectionSupportModules />
            <SectionSupportRules />
            <SectionSignUp />
        </div>
    );
}